module.exports = __webpack_public_path__ + "img/download_text.0af0dd1e.png";